module.exports = __webpack_public_path__ + "img/5f_r_belmont.515d8143.png";